<template>
    <div class="main">
        <div id="Nav" class="left">
            <div class="back"><button @click="goBack()" class="button icon fastic-circle-left" :aria-label="localizer.get('App.Common.PageBack')"></button></div>
            <div class="content">
                <h1 class="maintitle s60">{{ localizer.get("Account.User.Experience_Title") }}</h1>
                <div class="desc">{{ localizer.get("Account.User.Experience_Description") }}</div>
            </div>
            <app-footer></app-footer>
        </div>
        <main id="Main" class="right">
            <div class="logo" data-color="cyan50">
                <a :href="routes.Home"><img src="/images/logo.svg" width="125" height="35" :alt="localizer.get('App.Common.Beghelli')" /></a>
            </div>
            <div v-if="editData" @keydown.enter.prevent.stop="submitForm()" class="content">
                <div class="intro">
                    <h2 class="maintitle s36">{{ localizer.get("App.Common.AddFunctionalities") }}</h2>
                </div>
                <div ref="form" class="form">
                    <fieldset>
                        <div class="item" data-type="list">
                            <div v-for="(profileSegment, index) in profileSegments" :key="index" class="radio">
                                <input type="radio" name="profileSegments" :id="profileSegment.value" :value="profileSegment.value" v-model="formData.profileSegment">
                                <label :for="profileSegment.value">{{ profileSegment.title }}</label>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                            <ul>
                                <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                            </ul>
                        </div>
                        <div class="group" data-type="buttons">
                            <div class="cta">
                                <button :class="[{ 'loading': isSuccess }, 'button']" @click="submitForm()"><template v-if="!isSuccess">{{ localizer.get("Account.Common.Button_Next") }}</template></button>
                            </div>
                            <div v-if="!isSuccess" class="cta secondary">
                                <button class="button" @click="notNow()">{{ localizer.get("Account.Common.NotNow") }}</button>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{ returnUrl: string }>();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const profileSegments = ref<any[]>([]);
const editData = ref<any>(null);
const formData = ref<any>({ profileSegment: null });
const validationErrors = ref<any[]>([]);

onBeforeMount(() => {
    getData();
});

async function getData() {
    editData.value = (await Axios.post(routes.Account_Profile_GetEditSegmentData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    formData.value.profileSegment = editData.value.profileSegment;
    profileSegments.value = editData.value.profileSegments;
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;
    try {
        let result = (await Axios.post(routes.Account_Profile_EditSegment, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;
        window.location.href = result.redirectUrl ? result.redirectUrl : (props.returnUrl ? props.returnUrl : "/");
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
    isLoading.value = false;
}

function notNow() {
    window.location.href = props.returnUrl ? props.returnUrl : "/";
}

function goBack() {
    this.returnUrl ? window.location.href = this.returnUrl : history.back();
}
</script>
